export default __webpack_public_path__ + "static/Chevron_TCC22_Website_728x90-e9062117df64d0d63a84da0acafd4e21.jpg";